import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { Tooltip } from '@progress/kendo-react-tooltip'
import { ConservacionMensajeImage, EstampadoTiempoImage, iconoFirma1, iconoFirma2 } from '../../../assets/logos/icons'
import { EFirmaImage, FirmaAvanzadaImage } from '../../../assets/logos'

export default function cellDetailAditionalServices() {
  return class extends GridCell {
    render() {
      const { services } = this.props.dataItem
      const { signatureTypeId } = this.props.dataItem
      const { singMulti } = this.props.dataItem
      let signatureType = { signatureTypeName: '', signatureTypeIcon: null }
      switch (Number(signatureTypeId)) {
        case 1:
          signatureType.signatureTypeName = 'E.Firma'
          signatureType.signatureTypeIcon = EFirmaImage
          break
        case 2:
          signatureType.signatureTypeName = 'Firma Avanzada'
          signatureType.signatureTypeIcon = FirmaAvanzadaImage
          break
        case 3:
          signatureType.signatureTypeName = 'Firma Autografa'
          signatureType.signatureTypeIcon = iconoFirma1
          break
        default:
          signatureType.signatureTypeName = ''
          signatureType.signatureTypeIcon = null
      }
      return (
        <td className='cell-hide' >
          <div style={{ display: 'flex', alignItems: 'center' }} >
            <Tooltip openDelay={600} position="top" anchorElement="target" tooltipClassName="tooltipGeneralStyle">
              <span style={{ cursor: 'pointer', marginRight: '10px' }}>
                {(signatureType.signatureTypeIcon) ? <img src={signatureType.signatureTypeIcon && singMulti ? 'https://a3cloud-development.s3-us-west-2.amazonaws.com/microservices/MiFirma/assets/inbox/iconoFirma2.svg' : signatureType.signatureTypeIcon} title={signatureType.signatureTypeName} alt="imagen" width={18} /> : null}
              </span>
            </Tooltip>
            {
              services.map((item, index) => {
                if(item.serviceId === Number(process.env.REACT_APP_ADDITIONAL_SERVICES_CERTIFICATIONS)) return
                let serviceIcon
                if (item.serviceId === Number(process.env.REACT_APP_ADDITIONAL_SERVICES_TIME_DOCUMENT)) serviceIcon = EstampadoTiempoImage
                if (item.serviceId === Number(process.env.REACT_APP_ADDITIONAL_SERVICES_MESSAGE_PRESERVATION)) serviceIcon = ConservacionMensajeImage
                if (item.serviceId === Number(process.env.REACT_APP_ADDITIONAL_SERVICES_TIME_BY_SIGNATURE)) serviceIcon = EstampadoTiempoImage
                return (
                  <React.Fragment key={String(index)}>
                    <Tooltip openDelay={600} position="top" anchorElement="target" tooltipClassName="tooltipGeneralStyle">
                      <span style={{ cursor: 'pointer', marginRight: '10px' }}>
                        <img src={serviceIcon} title={item.name} alt="imagen" width={18} />
                      </span>
                    </Tooltip>
                  </React.Fragment>
                )
              })
            }
          </div>
        </td>
      )
    }
  }
}
